import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '.'

type CreateBillState = {
  submitBillPayload: {
    category: string
    recipient: string
    owneraddress: string | undefined
    number: string
    total: number
    currency: string | undefined
    date: string
    duedate: string
    description: string
    transactionHash?: string | undefined
    safeaddress: string
    budgetid: string
  }
}

const initialState: CreateBillState = {
  submitBillPayload: {
    category: '',
    recipient: '',
    owneraddress: '',
    number: '',
    total: 0,
    currency: '',
    date: '',
    duedate: '',
    description: '',
    transactionHash: '',
    safeaddress: '',
    budgetid: '',
  },
}

export const createBillSlice = createSlice({
  name: 'createBill',
  initialState,
  reducers: {
    setBillPayload: (state, action: PayloadAction<CreateBillState['submitBillPayload']>) => {
      state.submitBillPayload = {
        ...state.submitBillPayload,
        ...action.payload,
      }
    },

    updateTransactionHash: (state, action: PayloadAction<string | undefined>) => {
      state.submitBillPayload.transactionHash = action.payload
    },
  },
})

export const { setBillPayload, updateTransactionHash } = createBillSlice.actions

export const selectBillSubmit = (state: RootState): CreateBillState['submitBillPayload'] => {
  return state[createBillSlice.name].submitBillPayload
}
